export type Language = 'en' | 'ru' | 'uz' | 'fa';

/**
 * Persian is read right to left; the other three are read left to right.
 *
 * Lives here rather than next to the store because the root layout is a Server Component and
 * the store is `'use client'`. Imported across that boundary the map is a client reference,
 * not an object: indexing it on the server yields undefined, React drops the attribute, and
 * the document ships without `dir` — no build error, no runtime error, just a silently
 * left-to-right page for a Persian reader.
 */
export const LANGUAGE_DIR: Record<Language, 'ltr' | 'rtl'> = {
  en: 'ltr',
  ru: 'ltr',
  uz: 'ltr',
  fa: 'rtl',
};

export type TranslationsMap<T> = {
  en: T;
  ru: T;
  uz: T;
  fa: T;
};

export function createTranslations<T extends Record<string, string>>(
  translations: { en: T; ru: NoInfer<T>; uz: NoInfer<T>; fa: NoInfer<T> }
): TranslationsMap<T> {
  return translations;
}
